import { i18n } from "@lingui/core";
import { msg } from "@lingui/core/macro";

import { getPhase4TrustLinks, type Phase4TrustLink } from "@/integrations/multiresume/compliance/trust-copy";
import { cn } from "@/utils/style";

type TrustLinksProps = {
  links?: Phase4TrustLink[];
  className?: string;
  openInNewTab?: boolean;
};

const trustLinksAriaLabel = msg`Trust links`;
const legalAndSupportAriaLabel = msg`Legal and support`;

function resolveAriaLabel(descriptor: typeof trustLinksAriaLabel) {
  return i18n.locale ? i18n._(descriptor) : descriptor.message;
}

export function TrustLinks({ links, className, openInNewTab = false }: TrustLinksProps) {
  const items = links ?? getPhase4TrustLinks();
  const linkClassName = "underline-offset-4 hover:text-foreground hover:underline";
  const ariaLabel = resolveAriaLabel(trustLinksAriaLabel);

  return (
    <nav aria-label={ariaLabel} className={cn("flex flex-wrap gap-x-4 gap-y-2", className)}>
      {items.map((link) =>
        openInNewTab ? (
          <a key={link.href} href={link.href} target="_blank" rel="noreferrer" className={linkClassName}>
            {link.label}
          </a>
        ) : (
          <a key={link.href} href={link.href} className={linkClassName}>
            {link.label}
          </a>
        ),
      )}
    </nav>
  );
}

export function CompactTrustLinks({ className }: Pick<TrustLinksProps, "className">) {
  const items = getPhase4TrustLinks();
  const ariaLabel = resolveAriaLabel(legalAndSupportAriaLabel);
  const linkClassName = "underline-offset-4 hover:text-foreground hover:underline";

  return (
    <nav aria-label={ariaLabel} className={cn("flex flex-wrap items-start gap-x-4 gap-y-2", className)}>
      {items.map((link) => (
        <a key={link.href} href={link.href} className={linkClassName}>
          {link.label}
        </a>
      ))}
    </nav>
  );
}
